import {useFilterMenuContext} from 'src/app/components'
import {useUrlSearchParams} from 'src/app/hooks'

export function useFilterMenuSalesPromoPrizeListHook() {

  const [searchParams] = useUrlSearchParams< 'prize_statuses' | 'directory_ids' >()
  const defaultFilter = {
    directory_ids: searchParams.directory_ids,
    prize_statuses: searchParams.prize_statuses,
  }

  const filterContext = useFilterMenuContext<typeof searchParams>({defaultValues: defaultFilter})

  const claimedStatuses = [
    {
      label: 'Claimed',
      value: 'CLAIMED'
    },
    {
      label: 'Not Yet',
      value: 'PENDING'
    },
    {
      label: 'Expired',
      value: 'EXPIRED'
    },
  ];


  return ({
    filterContext,
    master: {
      claimedStatuses
    },
  })
}
